import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-07-reji-kumar-pillai-guest.webp";
import ThumbImg from "../../assets/images/conversations/007.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: rp-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .rp-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .rp-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .rp-hero { padding-top: 60px; padding-bottom: 60px; }
  .rp-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .rp-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .rp-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp-hero__title.rp-visible { opacity: 1; transform: translateY(0); }
  .rp-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .rp-hero__spotify.rp-visible { opacity: 1; transform: translateY(0); }
  .rp-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .rp-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .rp-hero__right.rp-visible { opacity: 1; transform: translateY(0); }

  .rp-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .rp-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .rp-yt-thumb:hover img { opacity: 0.85; }
  .rp-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .rp-yt-thumb__play img { width: 40px; height: 44px; }
  .rp-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .rp-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .rp-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp-body.rp-visible { opacity: 1; transform: translateY(0); }
  .rp-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .rp-body__para:last-child { margin-bottom: 0; }

  .rp-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .rp-guest.rp-visible { opacity: 1; transform: translateY(0); }
  .rp-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .rp-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .rp-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .rp-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .rp-inner { padding-left: 32px; padding-right: 32px; }
    .rp-hero { padding-top: 32px; padding-bottom: 48px; }
    .rp-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .rp-hero__title { font-size: 24px; }
    .rp-hero__left { gap: 16px; }
    .rp-guest__title { font-size: 24px; margin-bottom: 24px; }
    .rp-guest__photo-bg { width: 260px; height: 300px; }
    .rp-guest__name { font-size: 24px; margin-top: 18px; }
    .rp-body__para { font-size: 14px; margin-bottom: 12px; }
    .rp-body { padding-bottom: 48px; }
    .rp-guest { padding-bottom: 48px; }
    .rp-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .rp-inner { padding-left: 16px; padding-right: 16px; }
    .rp-hero { padding-top: 51px; padding-bottom: 30px; }
    .rp-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .rp-hero__left { gap: 30px; }
    .rp-hero__title { font-size: 30px; }
    .rp-body__para { font-size: 16px; margin-bottom: 10px; }
    .rp-guest__title { font-size: 30px; margin-bottom: 20px; }
    .rp-guest__photo-bg { width: 100%; height: 386px; }
    .rp-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .rp-body { padding-bottom: 30px; }
    .rp-guest { padding-bottom: 30px; }
    .rp-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("rp-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP07_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="rp-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 07 Reji Kumar Pillai"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="rp-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 07 Reji Kumar Pillai thumbnail" />
      <div className="rp-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="rp-hero">
      <div className="rp-inner">
        <div className="rp-hero__grid">
          <div className="rp-hero__left">
            <h1 ref={titleRef} className="rp-hero__title">
              EP 07 | Candid Conversation with Reji Kumar PILLAI, President of India Smart Grid Forum on charging standards in India, &amp; the power grid's ability to accommodate a massive move to E-Mobility
            </h1>
            <div ref={spotifyRef} className="rp-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0Ol4smCV3X7A8fSCH0AlkB?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 07 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="rp-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rp-body">
      <div className="rp-inner">
        <p className="rp-body__para">
          In today's episode, we change focus completely and move to the grid, the charging standards and the ability of the power network to be able to accommodate the growth that the government hopes to achieve in E-mobility within this decade. We really enjoyed recording this conversation for you which was with an imminently likeable and iconic personality driving change within the regulatory and policy spheres for E-mobility in India. Our conversation today is with Reji Kumar PILLAI, President of the India Smart Grid Forum and chairman of the Global Smart Energy Federation, known across the E-mobility and power sectors globally as a result. Working behind the scenes quite like Batman, Reji has been able to influence key policy changes to allow the charge point industry to come about in India and for the convergence in opinions on charging standards in the country.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="rp-guest">
      <div className="rp-inner">
        <h2 className="rp-guest__title">Our Guest</h2>
        <div>
          <div className="rp-guest__photo-bg">
            <img src={GuestImg} alt="Reji Kumar Pillai" />
          </div>
          <p className="rp-guest__name">Reji Kumar PILLAI</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep07RejiKumarPillai() {
  return (
    <>
      <style>{CSS}</style>
      <div className="rp-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}